import {combineReducers} from "redux";
import {reducer as companiesManagementReducer} from "./companiesManagement/reducer";
import {reducer as usersManagementReducer} from "./userManagement/reducer";
import {reducer as licensesReducer} from "./licenses/reducer";
import {reducer as licensePackagesReducer} from "./licensePackages/reducer";

const rootReducer = combineReducers({
    companiesManagementReducer: companiesManagementReducer,
    usersManagementReducer: usersManagementReducer,
    licensesReducer: licensesReducer,
    licensePackagesReducer: licensePackagesReducer,
})

export default rootReducer;
